import React, { useState, useEffect } from 'react';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import {
  Container,
  CheckPicker,
  Breadcrumb,
  Button,
  Divider,
  Table,
  Uploader,
  Message,
  Loader,
  Col,
  useToaster,
  Stack,
  Steps,
  Drawer,
  CheckboxGroup,
  Checkbox,
  TagPicker,
  Panel,
  FlexboxGrid,
  Form,
  ButtonToolbar,
  Input,
  InputGroup,
  InputNumber,
  Nav, SelectPicker, InputPicker,
  IconButton,
  ButtonGroup,
  Toggle,
} from 'rsuite';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import { Icon } from '@rsuite/icons';
import TrashIcon from '@rsuite/icons/Trash';
import PlusIcon from '@rsuite/icons/Plus';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import { mockUsers } from '../../../data/mock';
import FormGroup from 'rsuite/esm/FormGroup';






const Navbar = ({ active, onSelect, ...props }) => {
  return (
    <Nav {...props} activeKey={active} onSelect={onSelect}>
      <Nav.Item eventKey="home" className='links' href='#1'>
        Basic Details
      </Nav.Item>
      <Nav.Item eventKey="news" className='links' href='#2'>Product Information</Nav.Item>
      <Nav.Item eventKey="solutions" className='links' href='#3'>Internal Details</Nav.Item>
      <Nav.Item eventKey="products" className='links' href='#4'>Production Details</Nav.Item>
    </Nav>
  );
};

const data1 = [
  'Eugenia',
  'Bryan',
  'Linda',
  'Nancy',
  'Lloyd',
  'Alice',
  'Julia',
  'Albert',
  'Louisa',
  'Lester',
  'Lola',
  'Lydia',
  'Hal',
  'Hannah',
  'Harriet',
  'Hattie',
  'Hazel',
  'Hilda'
].map(item => ({ label: item, value: item }));

const size = ['CM', 'Inch'].map(
  item => ({ label: item, value: item })
);

const currency = [
  'INR',
  'USD',
  'UAE',
  'PNR',

].map(item => ({ label: item, value: item }));

const { Column, HeaderCell, Cell } = Table;
const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
const defaultColumns = [
  {
    key: 'id',
    label: 'Id',
    fixed: true,
    width: 70
  },
  {
    key: 'Pcode',
    label: 'Product Code',
    fixed: true,
    width: 130
  },
  {
    key: 'ProductType',
    label: 'Product Type',
    width: 130
  },
  {
    key: 'category',
    label: 'Carton Type',
    width: 123
  },
  {
    key: 'unit',
    label: 'Size Unit',
    width: 123
  },
  {
    key: 'length',
    label: 'Length',
    width: 123
  },

  {
    key: 'width',
    label: 'Width',
    width: 123
  },
  {
    key: 'height',
    label: 'Height',
    width: 123
  },
  {
    key: 'Color',
    label: 'Color',
    width: 123
  },
  {
    key: 'Finish',
    label: 'Finish',
    width: 123
  },
  {
    key: 'Description',
    label: 'Description',
    width: 123
  },
  {
    key: 'Buyer',
    label: 'Buyer',
    width: 123
  },

  {
    key: 'pcscarton',
    label: 'PCS/Carton',
    width: 123
  },
  {
    key: 'CBM',
    label: 'CBM',
    width: 200
  },
];

const defaultData = mockUsers(8);


const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
  const editing = rowData.status === 'EDIT';
  if (dataKey === "ProductType" || dataKey === "category" || dataKey === "unit" || dataKey === "Color" || dataKey === "Finish" || dataKey === "Buyer") {
    return (
      <Cell {...props} className={editing ? "table-content-editing" : ""}>
        {editing ? (
          <SelectPicker
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }} data={[]} />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );
  } else if (dataKey === "CBM" || dataKey === "id") {
    return (
      <Cell {...props} className={editing ? "table-content-editing" : ""}>
        {editing ? (
          <input
            className="rs-input"
            readOnly
            defaultValue={rowData[dataKey]}
            onChange={(event) => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );

  } else {
    return (
      <Cell {...props} className={editing ? "table-content-editing" : ""}>
        {editing ? (
          <input
            className="rs-input"
            defaultValue={rowData[dataKey]}
            onChange={(event) => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );

  }
}
const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} style={{ padding: '6px' }}>
      <Button
        onClick={() => {
          onClick(rowData.id);
        }}
      >
        {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
      </Button>
    </Cell>
  );
};

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
};

const ImageCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div
      style={{
        width: 40,
        height: 40,
        background: '#f5f5f5',
        borderRadius: 6,
        marginTop: 2,
        overflow: 'hidden',
        display: 'inline-block'
      }}
    >
      <img src={rowData.avatar} width="40" />
    </div>
  </Cell>
);




const Addprduct = () => {

  const [showInputs, setShowInputs] = useState(false);


  //  Rakesh code start
  const [serviceList, setServiceList] = useState([
    { CartonType: "", SizeUnit: "", Length: "", Width: "", Height: "", BoxArea: "", PCS: "", CBM: "", BoxWt: "" }
  ]);

  // console.log(serviceList);

  const handleServiceAdd = () => {
    setServiceList([...serviceList, { CartonType: "", SizeUnit: "", Length: "", Width: "", Height: "", BoxArea: "", PCS: "", CBM: "", BoxWt: "" }]);
  };
  const handleServiceRemove = (index) => {
    const list = [...serviceList];
    list.splice(index, 1);
    setServiceList(list);
  };

  const handleOnChange = (event, index) => {
    const { name, value } = event.target;
    const list = [...serviceList];
    list[index][name] = value;
    setServiceList(list);
  };
  // Rakesh code end

  const [inputs, setInputs] = useState([['', '', '']]);

  const handleInputChange1 = (setIndex, inputIndex, value) => {
    const newInputs = [...inputs];
    newInputs[setIndex][inputIndex] = value;
    setInputs(newInputs);
  };

  const handleAddInput = () => {
    const newInputs = [...inputs, ['', '', '']];
    setInputs(newInputs);
  };

  const handleDeleteInput = (setIndex) => {
    const newInputs = [...inputs];
    newInputs.splice(setIndex, 1);
    setInputs(newInputs);
  };

  const [active, setActive] = React.useState('home');
  const [compact, setCompact] = React.useState(false);
  const [noData, setNoData] = React.useState(false);
  const [autoHeight, setAutoHeight] = React.useState(false);
  const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));
  const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState(defaultData);

  const handleEditState = id => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find(item => item.id === id);
    activeItem.status = activeItem.status ? null : 'EDIT';
    setData(nextData);
  };


  const select = (e) => {

    // alert(e.target.value)
    let dwvalue = e.target.value;

    if (dwvalue == 'CM') {
      let m = num1 * num2 * num3 / 1000000;
      setResult(m);
    }
    else if (dwvalue == 'Inch') {
      let n = num1 * num2 * num3 / 61023;
      setResult(n);
    }
  }
  // add number start

  const [num1, setNum1] = useState(null);
  const [num2, setNum2] = useState(null);
  const [num3, setNum3] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    const sum = num1 * num2 * num3 / 1000000;
    setResult(sum);
  }, [num1, num2, num3]);

  function handleNum1Change(event) {
    setNum1(parseInt(event.target.value));
  }

  function handleNum2Change(event) {
    setNum2(parseInt(event.target.value));
  }

  function handleNum3Change(event) {
    setNum3(parseInt(event.target.value));
  }

  // add number end


  const toaster = useToaster();
  const [uploading, setUploading] = React.useState(false);
  const [fileInfo, setFileInfo] = React.useState(null);
  const [showtab, setShowtab] = useState(1);



  const handletab = (e) => {
    setShowtab(e);
  }

  const previous = () => {
    if (showtab == 2) {
      setShowtab(1)
    };
    if (showtab == 3) {
      setShowtab(2)
    };
  };
  const next = () => {
    if (showtab == 1) {
      setShowtab(2)

    };
    if (showtab == 2) {
      setShowtab(3)

    };
    if (showtab == 2) {

    };
  };

  const tableset = () => {
    setOpen(false);
    setData(mockUsers(value));

  };

  const [value, setValue] = React.useState(null);

  // stap code start
  const [step, setStep] = React.useState(0);
  const onChange = (nextStep) => {
    setStep(nextStep < 0 ? 0 : nextStep > 2 ? 2 : nextStep);
  };

  const onNext = () => {
    if (step === 2) {
      document.getElementById("first").style.display = "block";
      document.getElementById("second").style.display = "none";
      document.getElementById("third").style.display = "none";
    } else if (step === 0) {
      document.getElementById("first").style.display = "none";
      document.getElementById("second").style.display = "block";
      document.getElementById("third").style.display = "none";
    } else {
      document.getElementById("first").style.display = "none";
      document.getElementById("second").style.display = "none";
      document.getElementById("third").style.display = "block";
    }
    onChange(step + 1);
  };
  const onPrevious = () => {
    onChange(step - 1);
    if (step === 2) {
      document.getElementById("first").style.display = "none";
      document.getElementById("second").style.display = "block";
      document.getElementById("third").style.display = "none";
    } else if (step === 1) {
      document.getElementById("first").style.display = "block";
      document.getElementById("second").style.display = "none";
      document.getElementById("third").style.display = "none";
    }
  };
  // stap code end

  const [data5, setData5] = useState({
    Category: "",
    ProductType: " ",
    ProductCode: "",
    ProductId: "",
    ProductName: "",
    Description: "",
    SizeUnit: "",
    Length: "0",
    Width: "0",
    Height: "0",
    Finish: "",
    Color: "",
    NetWeight: "0",
    GrossWeight: "0",
    HSNCode: "",
    SellingPriceCurrency: "",
    SellingPriceUnit: "",
    SellingPrice: "0",
    ProductCost: "0",
    SearchKeyword: "",
    MOQ: " ",
    ProductDesigner: " ",
    MadeBy: " ",
    MaterialCollection: [
      {
        ProductCode: '',
        MatCollectionNm: ''
      }
    ],
    CoverImage: null,
    MultipleImage: [null] as any
    

  });



  const url2 = "http://192.168.1.83:1337/api/products"
  const submit = e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('files.CoverImage', data5.CoverImage);
    // formData.append('files.MultipleImage', data5.MultipleImage);
    data5.MultipleImage.forEach((file, index) => {
      formData.append(`files.MultipleImage[${index}]`, file.blobFile);
    });
    formData.append('data', JSON.stringify(data5));
    
    
    fetch(url2, {
      method: 'POST',
      body: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },

    })
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error(error));
      toaster1.push(message, { placement });
  };

  const message = (
    <Message showIcon type='success' closable>
      Saved Successfully
    </Message>
  );
  const message1 = (
    <Message showIcon type='error' closable>
      Please add atleast one Product.
    </Message>
  );
  const [placement, setPlacement] = React.useState('topCenter');
  const toaster1 = useToaster();

  // const submit = e => {
  //   e.preventDefault();
  //   fetch(url2, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify({ data: data5 })
  //   })
  //     .then(response => response.json())
  //     .then(data => console.log(data))
  //     .catch(error => console.error(error));
  //   }

  const handleInputChange = (inputName, value, index) => {
    if (inputName === 'MaterialCollection') {
      setData5(prevData => {
        const updatedMaterialCollection = [...prevData.MaterialCollection];
        updatedMaterialCollection[index] = {
          ...updatedMaterialCollection[index],
          [value.name]: value.value
        };
        return {
          ...prevData,
          MaterialCollection: updatedMaterialCollection
        };
      });
    } else {
      setData5({ ...data5, [inputName]: value });
    }
  };

  // const handleImageUpload = file => {
  //   setData5({
  //     ...data5,
  //     CoverImage: file
  //   });
  // };
  const handleImageUpload = fileList => {
    setData5({
      ...data5,
      CoverImage: fileList[0].blobFile
    });
  };
  // const handleImageUpload1 = fileList => {
  //   setData5({
  //     ...data5, 
  //     MultipleImage: fileList[0].blobFile
  //   });
  // };

  const handleImageUpload1 = fileList => {
    setData5({
      ...data5, 
      MultipleImage: fileList.map(file => file.blobFile)
    });
  };

  // const handleImageUpload = file => {
  //   setData5({
  //     ...data5,
  //     CoverImage: {
  //       data: {
  //         attributes: {
  //           url: URL.createObjectURL(file)
  //         }
  //       }
  //     }
  //   });
  // };
  // const handleImageUpload = (file) => {
  //   setData5({ ...data5, CoverImage:{
  //     data:{
  //       attributes:{
  //         url: file
  //       }
  //     }
  //   } });
  // };
  // const handleImageUpload = file => {
  //   setData5({ ...data5, image: file });
  // };
  // const handleImageUpload = (file) => {
  //   const imgjson = JSON.stringify(file);

  //   alert(imgjson)

  //   setData5({ ...data5, CoverImage: { data: { url: imgjson } }  });
  // };

  return (
    <>

      <Container className='main'>
        <Panel >
          <h3 className="title">Single Upload</h3>
          <Breadcrumb>
            <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/products">Product</Breadcrumb.Item>
            <Breadcrumb.Item>Add Product</Breadcrumb.Item>
          </Breadcrumb>
        </Panel>
        <Steps current={step} style={{ width: '42%', marginLeft: '12px' }}>
          <Steps.Item title="Basic Information" />
          <Steps.Item title="Variants" />
          <Steps.Item title="Package Loadability" />
        </Steps>

        <Divider />

        <div id="first">
          <FlexboxGrid justify="space-around">
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Uploader
                onChange={handleImageUpload}
                fileListVisible={false}
                listType="picture"
                action={""}
                onUpload={file => {
                  setUploading(true);
                  previewFile(file.blobFile, value => {
                    setFileInfo(value);
                  });
                }}
                onSuccess={(response, file) => {
                  setUploading(false);
                  toaster.push(<Message type="success">Uploaded successfully</Message>);
                  console.log(response);
                }}
                onError={() => {
                  setFileInfo(null);
                  setUploading(false);
                  toaster.push(<Message type="success">Uploaded successfully</Message>);
                }}
              >
                <button style={{ width: 255, height: 255 }}>
                  {uploading && <Loader backdrop center />}
                  {fileInfo ? (
                    <img src={fileInfo} width="100%" height="100%" />
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>
              <Stack wrap>
                <Uploader autoUpload={false}
                  onChange={handleImageUpload1} multiple listType="picture" action={""}>
                  <button>
                    <CameraRetroIcon />
                  </button>
                </Uploader>

              </Stack>
            </FlexboxGrid.Item>



            <FlexboxGrid.Item as={Col} colspan={24} md={14}>
              <Navbar appearance="subtle" active={active} onSelect={setActive} />

              <Form className='formScroll' >


                {/* <Uploader multiple
  accept="image/*"
  onChange={files => handleImageUpload(files)}
  action={''}>
                  <button>
                    <CameraRetroIcon />
                  </button>
                </Uploader> */}

                {/* <Uploader
                
                  autoUpload={false}
                  onChange={handleImageUpload}
                  fileListVisible={false} action={''}      >
        <button>Upload File</button>
      </Uploader> */}
                {/* <Uploader autoUpload={false}
                  onChange={handleImageUpload}
                  fileListVisible={false} multiple listType="picture" action="//jsonplaceholder.typicode.com/posts/">
            <button>
              <CameraRetroIcon />
            </button>
          </Uploader> */}

                {/* <input type="file" onChange={e => handleImageUpload(e.target.files[0])} /> */}

                <section id='1' >

                  <Divider ><b>Basic Details</b></Divider>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Category</Form.ControlLabel>
                    <Input
                      id="Category"
                      name="Category"
                      value={data5 && data5.Category ? data5.Category : ''} onChange={value => handleInputChange('Category', value)}
                    />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Type</Form.ControlLabel>
                    <Input name="ProductType" id='ProductType' value={data5 && data5.ProductType ? data5.ProductType : ''} onChange={value => handleInputChange('ProductType', value)} />
                  </Form.Group>
                  <Form.Group >
                    <Form.ControlLabel>Material Collection</Form.ControlLabel>
                    <Input id='ProductCode' name="ProductCode" value={data5 && data5.ProductCode ? data5.ProductCode : ''} onChange={value => handleInputChange('ProductCode', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Id</Form.ControlLabel>
                    <Input id='ProductId' name="ProductId" value={data5 && data5.ProductId ? data5.ProductId : ''} onChange={value => handleInputChange('ProductId', value)} />
                  </Form.Group>
                </section>
                <section id='2'>
                  <Divider ><b>Product Information</b></Divider>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Name</Form.ControlLabel>
                    <Input id='ProductName' name="ProductName" value={data5 && data5.ProductName ? data5.ProductName : ''} onChange={value => handleInputChange('ProductName', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel >Description</Form.ControlLabel>
                    <Input id='Description' name="Description" value={data5 && data5.Description ? data5.Description : ''} onChange={value => handleInputChange('Description', value)} placeholder="Textarea" />
                  </Form.Group>

                  <FlexboxGrid justify="space-between">
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Size</Form.ControlLabel>
                        <Input id='SizeUnit' name="SizeUnit" value={data5 && data5.SizeUnit ? data5.SizeUnit : ''} onChange={value => handleInputChange('SizeUnit', value)} />
                      </Form.Group>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Length</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='Length' name="Length" value={data5 && data5.Length ? data5.Length : ''} onChange={value => handleInputChange('Length', value)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Width</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='Width' name="Width" value={data5 && data5.Width ? data5.Width : ''} onChange={value => handleInputChange('Width', value)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Height</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='Height' name="Height" value={data5 && data5.Height ? data5.Height : ''} onChange={value => handleInputChange('Height', value)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group" >
                        <Form.ControlLabel >CBM</Form.ControlLabel>
                        <Input readOnly value={result} />
                      </Form.Group>
                    </FlexboxGrid.Item>

                  </FlexboxGrid>

                  <Form.Group controlId="input-group">
                    <Form.ControlLabel >Finish</Form.ControlLabel>
                    <Input id='Finish' name="Finish" value={data5 && data5.Finish ? data5.Finish : ''} onChange={value => handleInputChange('Finish', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel >Color</Form.ControlLabel>
                    <Input id='Color' name="Color" value={data5 && data5.Color ? data5.Color : ''} onChange={value => handleInputChange('Color', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Net Weight</Form.ControlLabel>
                    <InputNumber style={{ width: 'auto' }} id='NetWeight' name="NetWeight" value={data5 && data5.NetWeight ? data5.NetWeight : ''} onChange={value => handleInputChange('NetWeight', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Gross Weight</Form.ControlLabel>
                    <InputNumber style={{ width: 'auto' }} id='GrossWeight' name="GrossWeight" value={data5 && data5.GrossWeight ? data5.GrossWeight : ''} onChange={value => handleInputChange('GrossWeight', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>HSN</Form.ControlLabel>
                    <Input id='HSNCode' name="HSNCode" value={data5 && data5.HSNCode ? data5.HSNCode : ''} onChange={value => handleInputChange('HSNCode', value)} />
                  </Form.Group>


                  <FlexboxGrid justify="space-between">
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Selling Price</Form.ControlLabel>
                        <Input id='SellingPriceCurrency' name="SellingPriceCurrency" value={data5 && data5.SellingPriceCurrency ? data5.SellingPriceCurrency : ''} onChange={value => handleInputChange('SellingPriceCurrency', value)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={14}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Selling Price Unit</Form.ControlLabel>
                        <Input id='SellingPriceUnit' name="SellingPriceUnit" value={data5 && data5.SellingPriceUnit ? data5.SellingPriceUnit : ''} onChange={value => handleInputChange('SellingPriceUnit', value)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Selling Price</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='SellingPrice' name="SellingPrice" value={data5 && data5.SellingPrice ? data5.SellingPrice : ''} onChange={value => handleInputChange('SellingPrice', value)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </section>

                <section id='3'>
                  <Divider><b>Internal Details</b></Divider>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Cost</Form.ControlLabel>
                    <InputNumber style={{ width: 'auto' }} id='ProductCost' name="ProductCost" value={data5 && data5.ProductCost ? data5.ProductCost : ''} onChange={value => handleInputChange('ProductCost', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Search Keyword</Form.ControlLabel>
                    <Input id='SearchKeyword' name="SearchKeyword" value={data5 && data5.SearchKeyword ? data5.SearchKeyword : ''} onChange={value => handleInputChange('SearchKeyword', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>MOQ</Form.ControlLabel>
                    <Input id='MOQ' name="MOQ" value={data5 && data5.MOQ ? data5.MOQ : ''} onChange={value => handleInputChange('MOQ', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Designer</Form.ControlLabel>
                    <Input id='ProductDesigner' name="ProductDesigner" value={data5 && data5.ProductDesigner ? data5.ProductDesigner : ''} onChange={value => handleInputChange('ProductDesigner', value)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Made By</Form.ControlLabel>
                    <Input id='MadeBy' name="MadeBy" value={data5 && data5.MadeBy ? data5.MadeBy : ''} onChange={value => handleInputChange('MadeBy', value)} />
                  </Form.Group>
                  {/* <button type='submit' onClick={submit}> Submit</button> */}
                  <Form.Group controlId="input-group">
                    <Stack spacing={6} justifyContent="space-between">
                      Is this product exclusively made for a buyer ?
                      <Toggle checked={showInputs}
                        onChange={value => setShowInputs(value)} />
                    </Stack>
                    <Stack spacing={6}>
                      Click on the toggle to enter buyer details
                    </Stack>
                  </Form.Group>

                  {showInputs && (
                    <div>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                        <Input />
                      </Form.Group>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Buyer SKU</Form.ControlLabel>
                        <Input />
                      </Form.Group>
                    </div>
                  )}

                  {/* {toggle ? <span>
                    <Form.Group controlId="input-group">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <Input />
                  </Form.Group>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>Buyer SKU</Form.ControlLabel>
                      <Form.Control name="Product" />
                    </Form.Group></span> : <span></span>} */}
                </section>

                <section id='4'>
                  <Divider><b>Production Details</b></Divider>
                  <Form fluid>
                    {inputs.map((inputSet, setIndex) => (
                      <Stack spacing={10} key={setIndex} style={{ marginBottom: 10 }}>
                        {inputSet.map((input, inputIndex) => (
                          <FormGroup key={inputIndex}>
                            {inputIndex === 0 && (
                              <Form.ControlLabel>Material</Form.ControlLabel>
                            )}
                            {inputIndex === 1 && (
                              <Form.ControlLabel>Product Code</Form.ControlLabel>
                            )}
                            {inputIndex === 2 && (
                              <Form.ControlLabel>Finish</Form.ControlLabel>
                            )}
                            <Input
                              value={input}
                              onChange={(value) =>
                                handleInputChange1(setIndex, inputIndex, value)
                              }
                            />
                          </FormGroup>
                        ))}
                        {setIndex > 0 && (
                          <IconButton icon={<TrashIcon />} active onClick={() => handleDeleteInput(setIndex)} style={{ marginTop: '20px' }} />
                        )}
                      </Stack>
                    ))}
                    <IconButton icon={<PlusIcon />} onClick={handleAddInput}>Add</IconButton>
                  </Form>
                  {/* {serviceList1.map((singleService, index) => (
                    <FlexboxGrid>


                      <FlexboxGrid justify="space-between" key={index}>

                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          <Form.ControlLabel>Material</Form.ControlLabel>
                          {data5.MaterialCollection.map((material, index) => (
                            <div key={index}>
                              <Input
                                name="ProductCode"
                                value={material.ProductCode}
                                onChange={value => handleInputChange('MaterialCollection', { name: 'ProductCode', value: value }, index)}
                              />
                              <Input
                                name="MatCollectionNm"
                                value={material.MatCollectionNm}
                                onChange={value => handleInputChange('MaterialCollection', { name: 'MatCollectionNm', value: value }, index)}
                              />
                            </div>
                          ))}
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          <Form.ControlLabel >Finish</Form.ControlLabel>
                          <SelectPicker data={data1} block
                            placement="topStart"
                            name="Finish"
                            value={singleService.Finish}
                            onChange={(e) => handleOnChange1(e, index)}
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          {serviceList1.length > 1 && (
                            <IconButton size="md" icon={<TrashIcon />}
                              onClick={() => handleServiceRemove1(index)}
                              type="button"
                              className="remove-btn"
                            >
                            </IconButton>
                          )}
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          {serviceList1.length - 1 === index && serviceList1.length < 10 && (

                            <Panel>
                              <IconButton icon={<PlusIcon />}
                                onClick={handleServiceAdd1}
                                type="button"
                              >
                                <span>Add</span>
                              </IconButton>
                            </Panel>
                          )}
                        </FlexboxGrid.Item>

                      </FlexboxGrid>
                    </FlexboxGrid>
                  ))} */}
                </section>
              </Form>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </div>
        <div id="second" style={{ display: "none" }}>
          <Panel>
            <ButtonToolbar >
              <IconButton icon={<PlusIcon />} onClick={() => setOpen(true)} >Add Variants</IconButton>
            </ButtonToolbar>
          </Panel>
          <Panel>
            <Table
              height={300}
              data={noData ? [] : data}
            >
              {columns.map(column => {
                const { key, label, ...rest } = column;
                return (
                  <Column {...rest} key={key}>
                    <CustomHeaderCell>{label}</CustomHeaderCell>
                    <EditableCell dataKey={key} onChange={undefined} rowData={undefined} />
                  </Column>
                );
              })}
              <Column flexGrow={1}>
                <HeaderCell>Action</HeaderCell>
                <ActionCell dataKey="id" onClick={handleEditState} rowData={undefined} />
              </Column>
            </Table>
          </Panel>
          <Drawer open={open} onClose={() => setOpen(false)}>
            <Drawer.Header>
              <Drawer.Title>Add Variants</Drawer.Title>
              <Drawer.Actions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button color="cyan" onClick={tableset} appearance="primary">
                  Confirm
                </Button>
              </Drawer.Actions>
            </Drawer.Header>
            <Drawer.Body>
              <Panel>
                <Stack spacing={100} >
                  Variants:
                  <InputGroup >
                    <InputNumber value={value} onChange={setValue} defaultValue={10} min={1} />
                  </InputGroup>
                </Stack>
              </Panel>
              <Panel>
                <p>Select Attribute</p>
                <TagPicker
                  data={defaultColumns}
                  labelKey="label"
                  valueKey="key"
                  value={columnKeys}
                  onChange={setColumnKeys}
                  cleanable={false}
                />
                <Divider />
                <p>Suggested</p>
                <Stack justifyContent='flex-start' spacing={12}>
                  <CheckboxGroup>
                    <Checkbox value="A">Color</Checkbox>
                    <Checkbox value="K">Metarial</Checkbox>
                    <Checkbox value="C">Size</Checkbox>
                  </CheckboxGroup>

                  <CheckboxGroup>
                    <Checkbox value="D">Finish</Checkbox>
                    <Checkbox value="I">Name</Checkbox>
                    <Checkbox value="J">Vendor Name</Checkbox>
                  </CheckboxGroup>
                </Stack>
              </Panel>
            </Drawer.Body>
          </Drawer>
        </div>
        <div id="third" style={{ display: "none" }}>
          <Panel header="Packaging"  >
            <div>
              <Form fluid>
                {serviceList.map((singleService, index) => (
                  <div key={index} >
                    <FlexboxGrid justify="space-between">
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>Carton Type</Form.ControlLabel>
                          <SelectPicker data={data1} block
                            name="CartonType"
                            value={singleService.CartonType}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>Size Unit</Form.ControlLabel>
                          <SelectPicker data={data1} block
                            name="SizeUnit"
                            value={singleService.SizeUnit}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>Length</Form.ControlLabel>
                          <Input
                            placeholder="Length"
                            type="text"
                            name="Length"
                            required
                            value={singleService.Length}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>Width</Form.ControlLabel>
                          <Input
                            placeholder="Width"
                            type="text"
                            name="Width"
                            required
                            value={singleService.Width}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>Height</Form.ControlLabel>
                          <Input
                            placeholder="Height"
                            type="text"
                            name="Height"
                            required
                            value={singleService.Height}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>Box Area</Form.ControlLabel>
                          <Input
                            placeholder="Area"
                            readOnly
                            type="text"
                            name="BoxArea"
                            required
                            value={singleService.BoxArea}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>PCS</Form.ControlLabel>
                          <Input
                            type="text"
                            name="PCS"
                            required
                            value={singleService.PCS}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>CBM</Form.ControlLabel>
                          <Input
                            readOnly
                            type="text"
                            name="CBM"
                            required
                            value={singleService.CBM}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          <Form.ControlLabel>Gross Wt</Form.ControlLabel>
                          <Input
                            placeholder="Gross Wt."
                            type="text"
                            name="BoxWt"
                            required
                            value={singleService.BoxWt}
                            onChange={(e) => handleOnChange(e, index)}
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.Group controlId="name">
                          {serviceList.length > 1 && (
                            <IconButton size="md" icon={<TrashIcon />}
                              onClick={() => handleServiceRemove(index)}
                              type="button"
                              className="remove-btn"
                            >
                            </IconButton>
                          )}
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <Panel>
                        {serviceList.length - 1 === index && serviceList.length < 10 && (
                          <IconButton icon={<PlusIcon />}
                            onClick={handleServiceAdd}
                            type="button"
                          >
                            <span>Add</span>
                          </IconButton>
                        )}
                      </Panel>
                    </FlexboxGrid>
                  </div>
                ))}
              </Form>
            </div>
          </Panel>

          <Panel header="Loadability">

            <Form fluid>
              <FlexboxGrid justify="space-between">
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Total CBM</Form.ControlLabel>
                    <Form.Control name="name" />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Total CFT</Form.ControlLabel>
                    <Form.Control name="name" />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>20FT</Form.ControlLabel>
                    <Form.Control name="name" />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>40FT</Form.ControlLabel>
                    <Form.Control name="name" />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>40HQ</Form.ControlLabel>
                    <Form.Control name="name" />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>

          </Panel>

        </div>

        <Stack justifyContent="flex-end">
          <Panel>
            <ButtonGroup>
              <Button onClick={onPrevious} disabled={step === 0}>
                Previous
              </Button>
              {step === 2 ? (
                <Button color="cyan" appearance="primary" onClick={submit}>
                  Save
                </Button>
              ) : (
                <Button color="cyan" appearance="primary" onClick={onNext} disabled={step === 2}>
                  Next
                </Button>
              )}
            </ButtonGroup>
            {/* <ButtonGroup>
              <Button onClick={onPrevious} disabled={step === 0}>
                Previous
              </Button>
              <Button color="cyan" appearance='primary' onClick={onNext} disabled={step === 2}>
                Next
              </Button>
            </ButtonGroup> */}
          </Panel>
        </Stack>
        <Panel>
          &#169; Hitouch Technologies. All Right Reserved.
        </Panel>
      </Container>

    </>
  );
};

export default Addprduct;